var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-type mx-2 rounded px-2 py-1 d-flex"},[_c('IconShootingType',{attrs:{"type":_vm.type}}),(_vm.count)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.count))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }